module.exports = __webpack_public_path__ + "static/media/gilbert-on-couch-classic.f373f1c2.jpg";